// LIBRARIES
import styled, { css } from "styled-components";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";
import { Modal } from "@mui/material";

export const DatePickerDialog = styled(Modal)`
    && {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .MuiBackdrop-root {
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  `;

export const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 524px;
  background-color: ${COLORS.primaryAppWhite};
  border-radius: 24px;
  padding: 24px;
`;

export const CalendarsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-bottom: 13px;
  border-bottom: 3px solid #EBEBEB;
`;

export const CalendarContainer = styled.div`
  display: flex;
  flex-direction: column ;
  margin: 10px;
`;

export const CalendarHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const Select = styled.div`
  font-size: 16px;
  color: #1D1D26;
  font-family: ${FONTS.poppins};
  font-weight: bold;
  opacity: 1;
  margin-left: 10px; 
  margin-right: 10px;
  display: flex;
  flex-direction: row;
`;

export const Month = styled.div`
  margin-left: 10px;
  width: 100px;
`;

export const Year = styled.div`
  margin-left: 10px;
  width: 40px;
`;

export const WeekdaysRow = styled.div`
  display: flex;
  justify-content: space-around;
  font-size: 14px;
  color: #B6B7BF;
  font-family: ${FONTS.poppins};
  font-weight: medium;
  opacity: 1;
  margin-bottom: 10px;
`;

export const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  min-height: 150px;
`;

export const Day = styled.div<{ isActive?: boolean, isWithinRange?: boolean, isDatePicker?: boolean }>`
  height: ${props => props.isDatePicker ? '45px' : '30px'};
  width: ${props => props.isDatePicker ? '45px' : '30px'};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: ${props => props.isActive ? '#F5F5F5' : '#1D1D26'};
  font-family: ${FONTS.poppins};
  font-weight: bold;
  opacity: 1;
  background-color: ${props => props.isActive ? '#3356FF' : props.isWithinRange ? "#D6DCF7" : 'transparent'};
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    background-color: #3356FF;
    color: #F5F5F5;
  }
`;

export const ControlsWrapper = styled.div<{ isDatePicker?: boolean }>`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  margin-right: ${props => props.isDatePicker ? '32px' : '0px'};
`;

export const ButtonContainer = styled.div`
  margin-left: 32px;
`;

export const DateInputContainer = styled.div`
  width: 235px;
  height: 40px;
  border-radius: 16px;
  padding: 10px;
  background-color: #EBEBEB;
  cursor: pointer;
  margin-left: 16px;
  padding-left: 23px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Icon = styled.img`
 margin-right: 10px;
 width: 15px;
 height: 15px;
 left: 0px;
`;

export const Date = styled.div`
  font-size: 15px;
  color: #293462;
  font-family: ${FONTS.poppins};
  opacity: 1;
  // font-weight: 600;
`;

export const PlaceholderDate = styled.div`
  font-size: 15px;
  color: #B6B7BF;
  font-family: ${FONTS.poppins};
  opacity: 1;
  // font-weight: 600;
`;


